import { MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { csCZ } from "@mui/x-date-pickers/locales";
import { cs } from "date-fns/locale/cs";

const localeText =
	csCZ.components.MuiLocalizationProvider.defaultProps.localeText;

type Props = {
	open: boolean;
	onClose: () => void;
	onAccept: (value: Date) => void;
	value: Date | null;
	minDate?: Date;
};

export const ReminderDatePickerDialog = ({
	open,
	onClose,
	onAccept,
	value,
	minDate,
}: Props) => {
	return (
		<LocalizationProvider
			dateAdapter={AdapterDateFns}
			adapterLocale={cs}
			localeText={localeText}
		>
			<MobileDatePicker
				open={open}
				onClose={onClose}
				onAccept={(nextValue) => {
					if (nextValue) {
						onAccept(nextValue);
					}
					onClose();
				}}
				value={value}
				views={["year", "month", "day"]}
				minDate={minDate}
				closeOnSelect
				slotProps={{
					textField: { sx: { display: "none" } },
					mobilePaper: { className: "react-module" },
				}}
			/>
		</LocalizationProvider>
	);
};
